import React from 'react';

interface SunglassLogoProps {
  active?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const SunglassLogo: React.FC<SunglassLogoProps> = ({ active = false, className, style }) => {
  const fill = active ? '#FFFFFF' : '#ABABAB';

  return (
    <svg
      width="35"
      height="12"
      viewBox="0 0 46 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
        filter: active
          ? 'drop-shadow(0 0 4px rgba(200, 200, 200, 0.5)) drop-shadow(0 0 10px rgba(100, 100, 100, 0.3))'
          : 'none',
        transition: 'filter 0.25s ease',
      }}
    >
      <path d="M44.5795 0.997093C43.2008 0.687509 39.1804 -0.126052 35.58 0.0166421C31.1509 0.192199 27.1821 1.02533 25.2743 1.55134C24.2436 1.9241 22.6283 1.85848 22.6283 1.85848H22.4458C22.4458 1.85848 20.8305 1.9241 19.7998 1.55134C17.8923 1.02501 13.9235 0.19186 9.49403 0.0166421C5.89345 -0.126114 1.873 0.687821 0.494577 0.997093C0.203837 1.06236 0 1.31925 0 1.61732V3.66435C0 3.92438 0.158456 4.15822 0.399641 4.25491L0.46491 4.28109C0.649894 4.35508 0.779033 4.52157 0.801371 4.71946C0.968208 6.19617 1.77065 12.3925 3.64006 14.0504C5.76706 15.9362 8.76837 15.9118 10.525 15.9362C12.2813 15.9603 17.1447 16.8782 20.7084 6.68653C20.7733 6.50085 20.825 6.30784 20.8759 6.11796C20.9796 5.73159 21.2965 4.9505 22.168 4.88447H22.9062C23.7777 4.95009 24.0943 5.73122 24.1983 6.11796C24.2493 6.30784 24.3009 6.50085 24.3659 6.68653C27.9298 16.8779 32.7931 15.9603 34.5492 15.9362C36.3062 15.9121 39.3072 15.9362 41.4342 14.0504C43.3036 12.3932 44.1056 6.19662 44.2729 4.71946C44.2952 4.52157 44.4243 4.35508 44.6093 4.28109L44.6746 4.25491C44.9161 4.15823 45.0742 3.92438 45.0742 3.66435V1.61732C45.0735 1.31925 44.8693 1.06236 44.5786 0.997093H44.5795ZM4.13019 11.9819C3.95672 11.6957 3.81257 11.3879 3.70333 11.0615C3.45727 10.3279 3.18293 9.41693 2.97142 8.46793L7.98974 1.55509C8.56703 1.50134 9.10699 1.48284 9.55866 1.48284C10.3356 1.48284 10.8557 1.5338 10.8717 1.53555L10.8787 1.53589C11.1506 1.55614 11.4109 1.57918 11.6643 1.60396L4.13019 11.9819ZM28.5445 11.9261C28.0203 10.9942 27.5794 9.83822 27.2385 8.61456L32.2317 1.73656C32.8191 1.65803 33.4554 1.58753 34.1619 1.53483L34.1692 1.53448C34.1852 1.53273 34.7049 1.48177 35.4818 1.48177C35.6783 1.48177 35.8927 1.48527 36.1185 1.49364L28.5445 11.9261Z" fill={fill} />
    </svg>
  );
};
